<template>

  <el-dialog
    class="time-log-diff-modal"
    title="Revision Details"
    :visible.sync="diffModalOpened"
    :before-close="handleClose"
  >

    <div v-if="versionFromContext">
      <el-row>
        <el-col :span="12">
          <h3>Target version</h3>

          <div class="labeled-text">
            <p class="label">Changes made at:</p>
            <p class="text">{{ versionFromContext.created_at | formatTime }}</p>
          </div>

          <div class="labeled-text">
            <p class="text"><nl2br tag="span" :text="versionFromContext.model.text" /></p>
          </div>

          <div class="labeled-text">
            <p class="label">Author:</p>
            <p class="text">{{ author.email }}</p>
          </div>

        </el-col>
        <el-col :span="12">
          <h3>Current version</h3>

          <div class="labeled-text">
            <p class="label">Changes made at:</p>
            <p class="text">{{ currentPolicy.created_at | formatTime }}</p>
          </div>

          <div class="labeled-text" v-if="currentPolicy.text">
            <p class="label">Change description:</p>
            <p class="text"><nl2br tag="span" :text="currentPolicy.text" /></p>
          </div>
        </el-col>
      </el-row>

    </div>

    <span slot="footer" class="dialog-footer">
      <el-button type="danger" @click="handleRevertVersion" :loading="reverting">Revert</el-button>
      <el-button type="primary" @click="handleClose">Cancel</el-button>
    </span>

  </el-dialog>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';

  import { showSuccessMessage, showErrorMessage } from '@/ui/message';

  export default {
    name: 'VersionDiffModal',
    components: {
    },
    props: {
      onRevertSuccess: {
        type: Function,
      },
    },
    computed: {
      ...mapGetters('entities/versions', ['reverting', 'versionFromContext', 'diffModalAdditionalContext']),

      diffModalOpened: {
        get() {
          return this.$store.getters['entities/versions/diffModalOpened'];
        },
        set(newValue) {
          if (!newValue) {
            this.closeDiffModal();
          }
        },
      },

      currentPolicy() {
        return this.$store.getters['entities/policies/query']().first();
      },

      author() {
        return this.$store.getters['entities/users/find'](this.versionFromContext.user_id);
      },

    },
    methods: {
      ...mapActions('entities/versions', ['revertVersion', 'closeDiffModal', 'setContext']),

      handleRevertVersion() {
        this.$confirm('Do you really want to revert to this policy?', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          title: 'Confirm',
        }).then(() => {
          this.revertVersion(this.versionFromContext.id)
            .then((response) => {
              if (response.status) {
                this.handleClose();

                if (this.onRevertSuccess) this.onRevertSuccess(response);

                showSuccessMessage('Reverted successfully');
              } else {
                showErrorMessage(response.error);
              }
            });
        });
      },

      handleClose() {
        this.closeDiffModal();
        this.setContext(null);
      },

    },

  };
</script>



// WEBPACK FOOTER //
// src/components/version/VersionDiffModal.vue